export default {
	props: {

	},
	data() {
		return {
			importGridOptions: null,
			importNoticeShow: false,
			importColumns: [],
			importData: [],
			importTableRef: Math.random(),
			importLoading: false
		}
	},
	created() {

	},
	methods: {
		import() {


		},
		importpanel() {
			this.$api.module.moduleImporttemplate(this.componenttype, this.moduleName, {
				download: false
			}).then((res) => {
				this.importColumns = []
				res.forEach((item) => {
					this.importColumns.push({
						field: item.title,
						title: item.title,
						minWidth: 100,
						showHeaderOverflow:true,
						params: item,
						titlePrefix: {
							icon: 'vxe-icon-edit'
						},
						editRender: {
							name: '$input'
						},
						cellRender: {
							name: '$input'
						}
					})
				})

				this.importColumns.push({
					title: '操作',
					fixed: 'right',
					width: 80,
					slots: {
						default: 'operate'
					}
				})
				let importGridOptions = {
					border: true,
					height: 'auto',
					resizable: true,
					keepSource: true,
					showOverflow: true,
					align: 'left',
					toolbarConfig: {
						buttons: [{
							name: '导入',
							code: 'import',
							status: 'success',
						}, {
							name: '新增',
							code: 'add',
							status: 'primary',
						}, {
							name: '下载模板',
							code: 'importtemplate',
							status: '',
						}, {
							name: '清空',
							code: 'clear',
							status: '',
						}]
					},
					headerCellStyle: this.headerCellStyle,
					importConfig: {
						types: ['xls', 'xlsx'],
						remote: true,
						importMethod: this.importMethod,
					},
					editConfig: {
						trigger: 'click',
						mode: 'cell',
						showStatus: true,
						showIcon: false
					},
					columns: this.importColumns,
					data: this.importData
				}
				this.importGridOptions = importGridOptions
				this.importNoticeShow = true
			})

		},
		importMethod(e) {

			this.importColumns = []
			this.importData = []

			let file = e.file
			let reader = new FileReader();
			reader.onload = (e) => {
				let data = e.target.result
				let workbook = this.$XLSX.read(data, {
					type: 'binary'
				})
				let sheetName = workbook.SheetNames[0];
				let worksheet = workbook.Sheets[sheetName]
				let jsonData = this.$XLSX.utils.sheet_to_json(worksheet)
				if (jsonData.length != 0) {
					this.importGridOptions.data = jsonData
				} else {
					this.$message.error('暂无数据')
				}
			}
			reader.readAsBinaryString(file)


		},
		importMethod1(e) {

			this.importColumns = []
			this.importData = []

			let file = e.file
			let reader = new FileReader();
			reader.onload = (e) => {
				let data = e.target.result
				let workbook = this.$XLSX.read(data, {
					type: 'binary'
				})
				let sheetName = workbook.SheetNames[0];
				let worksheet = workbook.Sheets[sheetName]
				let jsonData = this.$XLSX.utils.sheet_to_json(worksheet)
				if (jsonData.length != 0) {

					//this.importData = []
					jsonData.forEach((item) => {
						let data = []
						if (Object.keys(item).length > this.importColumns.length) {
							this.importColumns = []
							for (let i in item) {
								this.importColumns.push({
									field: i,
									title: i,
									minWidth: 100,
									titlePrefix: {
										icon: 'vxe-icon-edit'
									},
									editRender: {
										name: '$input'
									},
									cellRender: {
										name: '$input'
									}
								})
							}
						}
						data.push(Object.values(item))
						// for (let i in item) {
						// 	data.push(item[i])
						// }
					})
					// this.importColumns.unshift({
					// 	type: 'seq',
					// 	title: '序号',
					// 	width: 50,
					// })
					this.importColumns.push({
						title: '操作',
						fixed: 'right',
						width: 80,
						slots: {
							default: 'operate'
						}
					})
					this.importData = jsonData
					let importGridOptions = {
						border: true,
						height: 'auto',
						resizable: true,
						keepSource: true,
						showOverflow: true,
						align: 'left',
						toolbarConfig: {
							buttons: [{
								name: '新增',
								code: 'add',
								status: 'primary',
							}, {
								name: '还原',
								code: 'revert',
							}, {
								name: '导出',
								code: 'exportdata',
								status: 'danger',
							}]
						},
						editConfig: {
							trigger: 'click',
							mode: 'cell',
							showStatus: true,
							showIcon: false
						},
						columns: this.importColumns,
						data: this.importData
					}
					this.importGridOptions = importGridOptions
					this.importNoticeShow = true
				} else {
					this.$message.error('暂无数据')
				}
			}
			reader.readAsBinaryString(file)


		},
		importApi() {

			let data = this.$refs[this.importTableRef].getTableData().fullData
			const ws = this.$XLSX.utils.json_to_sheet(data);
			const wb = this.$XLSX.utils.book_new();
			this.$XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
			const binary = this.$XLSX.write(wb, {
				bookType: "csv",
				type: "string"
			});

			let formData = new FormData()
			formData.append('excle', new Blob([binary], {
				type: 'application/octet-stream'
			}), 'excle.csv')
			this.importLoading = true
			this.$api.module.moduleImport(this.componenttype, this.moduleName, formData).then((res) => {
				if (res.errordata.data.length == 0) {
					this.$message.success('操作成功')
					this.importNoticeShow = false
				} else {
					this.$message.error('部分导入失败')
					this.$refs[this.importTableRef].reloadData(res.errordata.data)
				}
				this.customreload()
				this.importLoading = false
			}, () => {
				this.importLoading = false
			})

		},
		importdelete(e) {
			this.$refs[this.importTableRef].remove(e)
		},
		importToolbarButtonClick(e) {
			if (e.code == 'add') {
				this.$refs[this.importTableRef].insertAt({}, -1)
			}
			if (e.code == 'revert') {
				this.$refs[this.importTableRef].revertData()
			}
			if (e.code == 'exportdata') {
				this.$refs[this.importTableRef].exportData({
					filename: '错误数据',
					type: 'xlsx'
				})
			}
		},
		importtemplate() {
			this.$api.module.moduleImporttemplate(this.componenttype, this.moduleName).then((res) => {
				let a = document.createElement('a')
				a.setAttribute("href", window.config.importTemplate + res + '?v=' + Math.random())
				a.setAttribute("download", "")
				a.click()
			}, () => {

			})
		},
		headerCellStyle({
			column
		}) {
			if (column.params && column.params.require) {
				return {
					backgroundColor: '#F56C6C',
				}
			}
			if (column.params && column.params.unique) {
				return {
					backgroundColor: '#67C23A',
				}
			}
		},
	}
}
